import { useEffect } from "react";
import { showCommonAlert } from "../utils/show-common-alert-utils";

export default function CommonAlert({
	message,
	fallbackMessage,
	title = "Erro",
	icon = "error",
	confirmButtonText = "Ok",
	enabled = Boolean(message)
}) {
	useEffect(() => {
		if (!enabled) {
			return;
		}

		showCommonAlert({
			title,
			message,
			fallbackMessage,
			icon,
			confirmButtonText
		});
	}, [
		enabled,
		message,
		fallbackMessage,
		title,
		icon,
		confirmButtonText
	]);

	return null;
}